import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet.heat';
import MapBase from './MapBase';

function HeatLayer({ clusters, config }) {
  const map = useMap();

  useEffect(() => {
    if (!clusters?.length) return;

    const points = clusters.map((c) => [c.lat, c.lon, c.intens]);
    const layer = L.heatLayer(points, {
      radius: config?.radius ?? 30,
      blur: config?.blur ?? 20,
      minOpacity: config?.minOpacity ?? 0.4,
      maxZoom: 17,
    });
    layer.addTo(map);

    return () => {
      map.removeLayer(layer);
    };
  }, [map, clusters, config]);

  return null;
}

export default function MapDVFHeatmap({ latitude, longitude, clusters, config }) {
  if (!clusters?.length) return null;

  return (
    <MapBase latitude={latitude} longitude={longitude} zoom={13} height="400px" scrollWheelZoom={false}>
      <HeatLayer clusters={clusters} config={config} />
    </MapBase>
  );
}
